import { z } from 'zod';
import { optionalDate } from './Scheduling';
import { optionalNumber } from './OptionalNumber';
import { optionalString } from './OptionalString';

export const associatedCampaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.enum(['Lead', 'Opportunity']),
  status: optionalString,
  accountId: optionalNumber(),
  createdAt: optionalDate,
  updatedAt: optionalDate,
});

export type AssociatedCampaign = z.infer<typeof associatedCampaignSchema>;
